import { useRef, useCallback, useEffect } from 'react';

const IDLE_SAVE_DELAY = 10000;; // 10 sec
// Saves automatically after 1 minute of no edits
const useIdleAutoSave = ({ pendingChangesRef, performSave, view, isAuditFormOpen }) => {
  const idleTimerRef = useRef(null);

  const cancelIdleTimer = useCallback(() => {
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    idleTimerRef.current = null;
  }, []);

  const resetIdleTimer = useCallback(() => {
    cancelIdleTimer();

    idleTimerRef.current = setTimeout(() => {
      if (view || isAuditFormOpen) return;

      const current = pendingChangesRef.current;
      const hasUnsaved =
        current.created.size > 0 ||
        current.updated.size > 0 ||
        current.deleted.size > 0;

      if (hasUnsaved) {
        performSave();
      }
    }, IDLE_SAVE_DELAY);
  }, [cancelIdleTimer, pendingChangesRef, performSave, view, isAuditFormOpen]);

  useEffect(() => {
    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  return { resetIdleTimer, cancelIdleTimer };
};

export default useIdleAutoSave;